import parse from 'html-react-parser';
import { inputCls } from './TableCellText.style.js';
import { jsx } from 'react/jsx-runtime';

const TableCellText = ({
  cell
}) => {
  return /*#__PURE__*/jsx("span", {
    className: inputCls,
    children: /*#__PURE__*/jsx("span", {
      children: parse(cell.content ?? "")
    })
  });
};

export { TableCellText };
//# sourceMappingURL=TableCellText.js.map
